export function isMobileAppMode() {
  try {
    return window.sessionStorage.getItem("fromMobileApp") === "true";
  } catch {
    return false;
  }
}

export function mobileNavigateBack() {
  try {
    window.GameStatus?.postMessage?.("navigate_back");
  } catch {
    /* ignore */
  }
}

